import React from "react";
import { ActionButton } from "../../Common/Buttons/ActionButton";
import { Icon } from "../../Common/Icons/LucideIcons";
import { HeaderContainer, IconWrapper, Title } from "./__styles__/ChatHeader";

export type ChatHeaderProps = {
  onClose: () => void;
};

const ChatHeader = ({ onClose }: ChatHeaderProps) => {
  return (
    <HeaderContainer>
      <Title>
        <IconWrapper>
          <Icon iconName="sparkles" color="contentPrimary" size={18} />
        </IconWrapper>
        Forerunner assistant
      </Title>
      <ActionButton icon="x" onClick={onClose} aria-label="Close chat" />
    </HeaderContainer>
  );
};

export default ChatHeader;
